<template>
  <span class="cell-sortable" @click="cellSort">{{label}}<span class="caret-wrapper">
            <i :class="['sort-caret', 'ascending', {active: order===`${prop}_ascending`}]"></i>
            <i :class="['sort-caret', 'descending', {active: order===`${prop}_descending`}]"></i>
  </span>
  </span>
</template>

<script>
  export default {
    name: 'SortableHeader',
    props: {
      label: String,
      order: String,
      prop: String,
    },
    methods: {
      cellSort() {
        if (!this.$store.state.nodes.effReady) return;
        const { order, prop } = this;
        let orderBy = '';
        switch (order) {
          case '':
            orderBy = `${prop}_ascending`;
            break;
          case `${prop}_ascending`:
            orderBy = `${prop}_descending`;
            break;
          case `${prop}_descending`:
            orderBy = '';
            break;
          default:
            orderBy = `${prop}_ascending`;
        }
        this.$emit('sortData', {
          order: orderBy,
        });
      },
    },
  };
</script>
